/* import __COLOCATED_TEMPLATE__ from './tile-nav-content.hbs'; */
import Component from '@glimmer/component';
export default class BankingTileNavContent extends Component {}